import React, { useEffect } from "react"; // eslint-disable-next-line no-restricted-imports
import timer from "~/assets/img/v2/timer.png";

import { Col, UiBox, UiCenter, UiImage, UiText, useBreakpointValue } from "~/components/elements";
import { useAppDispatch, useAppSelector } from "~/hooks";
import { setActiveStep } from "~/redux/dashboards/slice";
import { fetchMyListJob } from "~/redux/dashboards/thunk";
import { DashboardMainBox } from "~/components/shared/DashboardMainBox";
import { PageLayout } from "~/components/layouts/PageLayout";
import { DashboardStepper } from "~/components/shared/DashboardStepper";
import { useHistory } from "react-router-dom";
import { PAGES } from "~/constants";
import { JOB_STATUS_PROCESSING } from "~/constants/job";

export function CompletedPage() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const vrTitle = useBreakpointValue<any>({ base: "headline4", md: "headline2" });
  const vrCaption = useBreakpointValue<any>({ base: "body2", md: "body1" });
  const jobData = useAppSelector(state => state.dashboard.jobData);
  const hasJobProcessing = jobData?.some(j => j.status === JOB_STATUS_PROCESSING);

  useEffect(() => {
    dispatch(setActiveStep({ step: 4 }));
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchMyListJob({}));
    };

    const interval = setInterval(() => {
      fetchData();
    }, 20000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch]);

  useEffect(() => {
    if (!hasJobProcessing) {
      history.push(PAGES.VIEW_RESULTS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasJobProcessing]);

  const onClickBack = async () => {
    history.push(PAGES.DASHBOARD);
  };

  const onClickNext = async () => {
    history.push(PAGES.VIEW_RESULTS);
  };

  return (
    <PageLayout
      metaTagsConfig={{
        title: `Bettershot - Processing`,
        description: `Get 120 professional photoshoots in 3 hours using AI. Elevate your personal brand with corporate photoshoots.`,
        charset: "utf8",
        lang: "en",
        metas: [
          {
            name: "keywords",
            content: "corporate photoshoot,professional photoshoot,bettershot ai,linkedin profile photo,ai photoshoot",
          },
          { name: "robots", content: "noindex,nofollow" },
        ],
        links: [{ rel: "canonical", href: window.location.href }],
      }}
      as={Col}
      flex={1}
      isInGeneratingStep={false}
    >
      <Col flex={1} justify="center">
        <UiCenter p={4} gap={5} flexDirection={{ base: "column-reverse", lg: "row" }}>
          <DashboardMainBox>
            <Col w="full" h="full">
              <UiBox w={{ base: "full", md: "66%" }} mx="auto">
                <UiText vr={vrTitle} textAlign="center">
                  Processing your photos
                </UiText>
                <UiText vr={vrCaption} mt={{ base: 2, sm: 3 }} textAlign="center">
                  Your images are being generated and will be completed within
                  <b style={{ color: "black" }}> 3 hours</b>. We&apos;ll email you when they&apos;re ready!
                </UiText>
              </UiBox>

              <UiCenter
                rounded="2xl"
                mt={{ base: 4, md: 8 }}
                p={{ base: 7, md: 5 }}
                flex={1}
                borderStyle="dashed"
                borderWidth="1px"
                borderColor="neutral.gray200"
              >
                <Col align="center">
                  <UiImage src={timer} w="5rem" h="5rem" className="rotating" />
                  <UiText vr="headline4" mt={6}>
                    Processing
                  </UiText>
                </Col>
              </UiCenter>
            </Col>
          </DashboardMainBox>
          <DashboardStepper />
        </UiCenter>
      </Col>
    </PageLayout>
  );
}
